import React from 'react';
import { Link } from 'react-router-dom';
import ResponsiveImage from "./ResponsiveImage";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock } from '@fortawesome/free-solid-svg-icons';
import { toFarsiRelativeTime } from '../utils/dateUtils';

const BlogCard = ({ blog }) => {
    if (!blog) return null;

    return (
        <div className="w-full transition hover:-translate-y-3">
            <div className="relative">
                <ResponsiveImage
                    src={blog.image}
                    alt={blog.title}
                    className="w-full rounded-md h-64 object-cover"
                />

                {/* Bottom-left read time box */}
                <div className="absolute bottom-2 left-2 bg-white/90 text-gray-800 text-xs px-3 py-1 rounded-full flex items-center gap-1 shadow">
                    <FontAwesomeIcon icon={faClock} />
                    <span>{blog.read_time} دقیقه </span>
                </div>
            </div>

            <div className="py-8 px-6">
                <h2 className="text-xl line-clamp-2 leading-relaxed font-bold">{blog.title}</h2>

                <span className="text-lg mt-5">
                    <span>{blog.category}</span>
                </span>

                <p className="text-md mt-5">{toFarsiRelativeTime(blog.created_at)}</p>
            </div>
        </div>
    );
};

export default BlogCard;
